// src/utils/auth.js
let currentUser = null;      // { user_id, emp_id, bo_id, roles }
let currentPermissions = {}; // { screen_name: [permission1, permission2] }

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const fetchCurrentUser = async () => {
  try {
    let res = await fetch(`${BASE_URL}/api/me`, {
      credentials: "include",
    });

    // If access token expired, try refresh once
    if (res.status === 401) {
      const refreshRes = await fetch(`${BASE_URL}/api/auth/refresh-token`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({}),
      });
      if (refreshRes.ok) {
        res = await fetch(`${BASE_URL}/api/me`, { credentials: "include" });
      }
    }

    if (!res.ok) throw new Error("Not authenticated");
    const data = await res.json();
    currentUser = data.user;
    currentPermissions = data.permissions;
    return data.user;
  } catch (err) {
    currentUser = null;
    currentPermissions = {};
    console.error("Failed to fetch current user:", err);
    return null;
  }
};

// Logout flag to prevent multiple redirects
let isLoggingOut = false;

// Logout function
export const logout = async () => {
  if (isLoggingOut) return; // Prevent multiple logout calls
  isLoggingOut = true;
  
  try {
    await fetch(`${BASE_URL}/api/logout`, {
      method: "POST",
      credentials: "include",
    });
  } catch (err) {
    console.error("Logout error:", err);
  } finally {
    // No need to clear localStorage - using HttpOnly cookies
    currentUser = null;
    currentPermissions = {};
    window.location.href = "/login";
  }
};

export const isLoggingOutFlag = () => isLoggingOut;

// User getters
export const getUserId = () => currentUser?.user_id || null;
export const getEmpId = () => currentUser?.emp_id || null;
export const getBoId = () => currentUser?.bo_id || null;
export const getUserRole = () => currentUser?.roles || [];
export const hasRole = (roleName) => getUserRole().includes(roleName);

// Permissions
export const getUserPermissions = () => currentPermissions;

export const hasPermission = (screen, permissionType) => {
  if (!currentPermissions) return false;
  const perms = currentPermissions[screen];
  if (!perms) return false;
  return perms.some(
    (p) => p.toLowerCase() === permissionType.toLowerCase()
  );
};